import { render, staticRenderFns } from "./pos-app-releases.vue?vue&type=template&id=3b1956d4&scoped=true"
import script from "./pos-app-releases.vue?vue&type=script&lang=js"
export * from "./pos-app-releases.vue?vue&type=script&lang=js"
import style0 from "./pos-app-releases.vue?vue&type=style&index=0&id=3b1956d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1956d4",
  null
  
)

export default component.exports